import { theme } from '@echo/tokens';
import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge only knows Tailwind's stock scale: it reads `text-headline-md` as a *colour*
 * and drops it when a `text-on-*` tone follows, and it can't tell `p-content-sm` and
 * `p-content-md` apart. Teach it the DESIGN.md type levels (`text-<level>` = font-size) and
 * spacing tokens (padding, margin, gap, sizes, insets) so overrides merge the way they read.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: { spacing: Object.keys(theme.spacing) },
    classGroups: {
      'font-size': [{ text: Object.keys(theme.typography) }],
    },
  },
});

export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
